<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper register-surv">
    <div class="container-fluid">
      <div class="content-field d-flex align-items-center w-100 p-0">
        <div class="login-group-left">
          <div class="login-wrapper register-wrapper">
            <header class="logo-header"></header>

            <div class="login-inbox">
              <div class="log-auth register-auth">
                <div class="login-auth-wrap">
                  <div class="login-content-head">
                    <h3>Sign Up</h3>

                    <p v-if="message" class="text-success">{{message}}</p>
                    <p v-if="errorMessage" class="invalid-feedback-text text-danger">{{errorMessage}}</p>

                    <div v-if="message" class="bottom-text text-center">
                      <p>
                        <router-link to="/">Go to Login</router-link>
                      </p>
                    </div>
                  </div>
                </div>

                <Form
                  v-if="!finished"
                  class="sign up"
                  @submit="onSubmit"
                  :validation-schema="schema"
                  v-slot="{ errors }"
                >
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="form-label">Sex <span>*</span></label>

                        <Field v-model="form.gender" name="gender" as="select" class="form-control">
                          <option value="">Select</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </Field>

                        <div v-if="genderError" class="invalid-feedback-text">{{genderError}}</div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="form-label">Age (> 18) <span>*</span></label>

                        <Field v-model="form.age" name="age" type="number" class="form-control" min="18" max="100"/>

                        <div v-if="ageError" class="invalid-feedback-text">{{ageError}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="form-label">Email <span>*</span></label>

                    <Field
                      v-model="form.email"
                      name="email"
                      type="text"
                      class="form-control mt-2"
                      :class="{ 'is-invalid': errors.email }"
                    />

                    <div class="invalid-feedback">{{ errors.email }}</div>
                    <div class="emailshow text-danger" id="email"></div>
                  </div>

                  <div class="form-group">
                    <label class="form-label">Username <span>*</span></label>

                    <Field
                      v-model="form.username"
                      name="username"
                      type="text"
                      class="form-control mt-2"
                      :class="{ 'is-invalid': errors.username }"
                    />

                    <div class="invalid-feedback">{{ errors.username }}</div>
                    <div class="emailshow text-danger" id="username"></div>
                  </div>

                  <div class="form-group">
                    <label class="form-label">Password <span>*</span></label>

                    <div class="pass-group" id="passwordInput">
                      <Field
                        v-model="form.password"
                        name="password"
                        :type="showPassword ? 'text' : 'password'"
                        class="form-control pass-input mt-2"
                        :class="{ 'is-invalid': errors.password }"
                      />

                      <span @click="toggleShow" class="toggle-password">
                      <i :class="{
                        'fas fa-eye': showPassword,
                        'fas fa-eye-slash': !showPassword,
                       }"
                      ></i>
                    </span>

                      <div class="invalid-feedback">{{ errors.password }}</div>
                      <div class="emailshow text-danger" id="password"></div>
                    </div>

                    <div
                      class="password-strength d-none"
                      :class="{ active: infoColor }"
                      id="passwordStrength"
                      :style="{ color: infoColor }"
                    >
                      <span id="poor" :class="{ active: isPoor }"></span>
                      <span id="weak" :class="{ active: isWeak }"></span>
                      <span id="strong" :class="{ active: isStrong }"></span>
                      <span id="heavy" :class="{ active: isHeavy }"></span>
                    </div>

                    <div id="passwordInfo" :style="{ color: infoColor }">
                      {{ infoText }}
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <div class="pass-login">
                      <label class="form-label">Looking for <span class="field-required">*</span></label>
                      <vue-select :settings="vueSelectSettings" :options="lookingForList" placeholder="Women/Men" v-model="form.looking_for" />

                      <div v-if="lookingForError" class="invalid-feedback-text">{{lookingForError}}</div>
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <div class="pass-login">
                      <label class="form-label">Civil status <span class="field-required">*</span></label>
                      <vue-select :settings="vueSelectSettings" :options="civilStatuses" placeholder="Civil status" v-model="form.marriage_status" />

                      <div v-if="civilStatusError" class="invalid-feedback-text">{{civilStatusError}}</div>
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <div class="pass-login">
                      <label class="form-label">Country <span class="field-required">*</span> <small class="d-block text-gray">set for best matches</small> </label>
                      <vue-select :settings="vueSelectSettings" :options="countries" placeholder="Country" v-model="form.country" />

                      <div v-if="countryError" class="invalid-feedback-text">{{countryError}}</div>
                    </div>
                  </div>

                  <div class="form-group form-remember d-flex align-items-center justify-content-between mb-2">
                    <div class="form-check d-flex align-items-center justify-content-start ps-0">
                      <label class="custom-check mt-0 mb-0">
                      <span class="remember-me">
                        I Agree to <a href="#" class="app-link">Terms of Use</a> and <a href="#" class="app-link">Privacy Policy</a>
                      </span>

                        <input v-model="form.agree_terms" name="agree_terms" type="checkbox"/>
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>

                  <div class="form-group form-remember d-flex align-items-center justify-content-between">
                    <div class="form-check d-flex align-items-center justify-content-start ps-0">
                      <label class="custom-check mt-0 mb-0">
                      <span class="remember-me">
                        I Agree that I am at least 18 years old
                      </span>

                        <input v-model="form.agree_age" name="agree_terms" type="checkbox"/>
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>

                  <div v-if="termsError" class="invalid-feedback-text py-2">{{termsError}}</div>

                  <div class="mb-5">
                    <button type="submit" class="btn btn-primary w-100 btn-size justify-content-center" @click="onSubmit">
                      Sign Up
                    </button>
                  </div>

                  <div class="bottom-text text-center">
                    <p>
                      Already have an account?
                      <router-link to="/">Login</router-link>
                    </p>
                  </div>

                  <div class="bottom-text text-center">
                    <p>
                      <a :href="websiteUrl">Go to Website</a>
                    </p>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import {Form, Field} from "vee-validate";
import * as Yup from "yup";
import {mapGetters} from "vuex";
import config from "@/config.js";

export default {
  data() {
    return {
      vueSelectSettings: {
        allowClear: true,
        closeOnSelect: true,
      },
      finished: false,
      message: '',
      errorMessage: '',
      genderError: '',
      countryError: '',
      termsError: '',
      ageError: '',
      lookingForError: '',
      civilStatusError: '',
      form: {
        age: false,
        gender: false,
        username: '',
        email: '',
        password: '',
        agree_terms: false,
        agree_age: false,
        country: '',
        looking_for: '',
        marriage_status: '',
      },
      showPassword: false,
      password: null,
      infoColor: "",
      isPoor: "",
      isWeak: "",
      isStrong: "",
      isHeavy: "",
      infoText: "",
      emailError: "",
      passwordError: "",
      schema: Yup.object().shape({
        gender: Yup.string().required("Gender is required"),
        country: Yup.string().required("Country is required"),
        age: Yup.number().min(18).max(100).required("Age is required"),
        username: Yup.string().required("Username is required")
          .matches(/^[a-zA-Z0-9]+$/, "Only letters and digits allowed"),
        email: Yup.string().required("Email is required").email("Email is invalid"),
        password: Yup.string()
          .min(6, "Password must be at least 6 characters")
          .required("Password is required"),
        agree_terms: Yup.boolean().required('Please agree to terms and conditions'),
        agree_age: Yup.boolean().required('Please agree that you have over 18 years'),
      }),
    };
  },

  computed: {
    ...mapGetters({
      countries: 'misc/countries',
      lookingForList: 'misc/lookingForList',
      civilStatuses: 'misc/civilStatuses',
    }),

    websiteUrl() {
      return config.WEBSITE_URL;
    },

    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },

  methods: {
    resetForm() {
      this.form = {
        looking_for: '',
        marriage_status: '',
        age: false,
        gender: false,
        country: '',
        username: '',
        email: '',
        password: '',
        agree_terms: false,
        agree_age: false,
      };
    },

    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    submitForm() {
      this.$router.push("/");
    },

    async onSubmit() {
      this.finished = false;
      this.message = '';
      this.errorMessage = '';
      this.genderError = !this.form.gender ? 'Gender is required' : '';
      this.countryError = !this.form.country ? 'Country is required' : '';
      this.lookingForError = !this.form.looking_for ? 'Looking for is required' : '';
      this.civilStatusError = !this.form.marriage_status ? 'Civil status is required' : '';
      this.ageError = (this.form.age < 18 || this.form.age > 100) ? 'Invalid age' : '';
      this.termsError = !this.form.agree_terms || !this.form.agree_age ? 'Please agree to terms and conditions' : '';

      const required = [
        'gender',
        'username',
        'email',
        'password',
        'agree_terms',
        'agree_age',
        'age',
        'country',
        'looking_for',
        'marriage_status',
      ];

      for (let key of required) {
        if (!this.form[key]) {
          return;
        }
      }

      if (this.form.password.length < 6) {
        return
      }

      if (this.genderError || this.countryError || this.ageError || this.termsError) {
        return;
      }

      const r = await this.$store.dispatch('auth/register', this.form);

      if (r.success) {
        this.resetForm();
        this.message = 'Congratulations! You will receive an e-mail shortly.';
        this.finished = true;
      } else {
        this.errorMessage = r.message ? r.message : r.data.message;
      }
    },
  },

  mounted() {
    if (document.getElementById("passwordInput")) {
      let passwordInput = document
        .getElementById("passwordInput")
        .getElementsByTagName("input")[0];
      let passwordStrength = document.getElementById("passwordStrength");
      let poor = document.getElementById("poor");
      let weak = document.getElementById("weak");
      let strong = document.getElementById("strong");
      let heavy = document.getElementById("heavy");
      let passwordInfo = document.getElementById("passwordInfo");
      let passcheck = document.getElementsByClassName("pass-checked")[0];

      let poorRegExp = /[a-z]/;
      let weakRegExp = /(?=.*?[0-9])/;
      let strongRegExp = /(?=.*?[#?!@$%^&*-])/;

      let whitespaceRegExp = /^$|\s+/;

      passwordInput.oninput = function () {
        let passwordValue = passwordInput.value;
        let passwordLength = passwordValue.length;
        let poorPassword = passwordValue.match(poorRegExp);
        let weakPassword = passwordValue.match(weakRegExp);
        let strongPassword = passwordValue.match(strongRegExp);
        let whitespace = passwordValue.match(whitespaceRegExp);
        if (passwordValue !== "") {
          passwordStrength.style.display = "block";
          passwordStrength.style.display = "flex";
          passwordInfo.style.display = "block";
          passwordInfo.style.color = "black";
          if (whitespace) {
            passwordInfo.textContent = "whitespaces are not allowed";
          } else {
            poorPasswordStrength(
              passwordLength,
              poorPassword,
              weakPassword,
              strongPassword
            );
            weakPasswordStrength(
              passwordLength,
              poorPassword,
              weakPassword,
              strongPassword
            );
            strongPasswordStrength(
              passwordLength,
              poorPassword,
              weakPassword,
              strongPassword
            );
            heavyPasswordStrength(
              passwordLength,
              poorPassword,
              weakPassword,
              strongPassword
            );
          }
        } else {
          passwordInfo.style.display = "none";
          passwordStrength.classList.remove("poor-active");
          passwordStrength.classList.remove("avg-active");
          passwordStrength.classList.remove("strong-active");
          passwordStrength.classList.remove("heavy-active");
        }
      };

      function poorPasswordStrength(
        passwordLength,
        poorPassword,
        weakPassword,
        strongPassword
      ) {
        if (passwordLength < 8) {
          poor.classList.add("active");
          passwordStrength.classList.add("poor-active");
          passwordStrength.classList.remove("avg-active");
          passwordStrength.classList.remove("strong-active");
          passwordStrength.classList.remove("heavy-active");
          passwordInfo.style.display = "block";
          passwordInfo.style.color = "#FF0000";
        }
      }

      function weakPasswordStrength(
        passwordLength,
        poorPassword,
        weakPassword,
        strongPassword
      ) {
        if (passwordLength >= 8 && (poorPassword || weakPassword || strongPassword)) {
          weak.classList.add("active");
          passwordStrength.classList.remove("poor-active");
          passwordStrength.classList.add("avg-active");
          passwordStrength.classList.remove("strong-active");
          passwordStrength.classList.remove("heavy-active");
          passwordInfo.style.display = "block";
          passwordInfo.style.color = "#FFB54A";
        } else {
          weak.classList.remove("active");
        }
      }

      function strongPasswordStrength(
        passwordLength,
        poorPassword,
        weakPassword,
        strongPassword
      ) {
        if (passwordLength >= 8 && poorPassword && (weakPassword || strongPassword)) {
          strong.classList.add("active");
          passwordStrength.classList.remove("avg-active");
          passwordStrength.classList.remove("poor-active");
          passwordStrength.classList.add("strong-active");
          passwordStrength.classList.remove("heavy-active");
          passwordInfo.style.color = "#1D9CFD";
        } else {
          strong.classList.remove("active");
        }
      }

      function heavyPasswordStrength(
        passwordLength,
        poorPassword,
        weakPassword,
        strongPassword
      ) {
        if (passwordLength >= 8 && poorPassword && weakPassword && strongPassword) {
          heavy.classList.add("active");
          passwordStrength.classList.remove("poor-active");
          passwordStrength.classList.remove("avg-active");
          passwordStrength.classList.remove("strong-active");
          passwordStrength.classList.add("heavy-active");
          passwordInfo.style.color = "#159F46";
        } else {
          heavy.classList.remove("active");
        }
      }
    }
  },

  components: {
    Form,
    Field,
  },
};
</script>
